module.exports = __webpack_public_path__ + "img/bitcoin.d00f1e58.svg";